export const CONTROL_VENUE_STATUSES= 'CONTROL_VENUE_STATUSES'
export const CONTROL_VENUE_STATUSES_SUCCESS= 'CONTROL_VENUE_STATUSES_SUCCESS'
export const CONTROL_VENUE_STATUSES_ERROR='CONTROL_VENUE_STATUSES_ERROR'

export const ControlVenueStatuses= (data) => ({
    type: CONTROL_VENUE_STATUSES,
    payload: data
})